import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Switch from '@mui/material/Switch';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {
  Restore,
  ViewStream,
  ViewList,
  ViewHeadline
} from '@mui/icons-material';

const styles = theme => ({
  selectedButton: {
    background: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  root: {
    height: 30
  }
});

class GeneralSettings extends Component {

  render() {
    const {
      classes,
      settings,
      onSwitch,
      density,
      onRestore,
      onDensityChange
    } = this.props;

    return (
      <div>
        <List>
          <ListItem>
            <ListItemText primary="Autosave column width" />
            <ListItemSecondaryAction>
              <Switch
                onChange={onSwitch('autosaveWidth')}
                checked={settings.autosaveWidth}
                color="primary"
              />
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />

          <ListItem>
            <ListItemText primary="Autosave column order" />
            <ListItemSecondaryAction>
              <Switch
                onChange={onSwitch('autosaveOrder')}
                checked={settings.autosaveOrder}
                color="primary"
              />
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />

          <ListItem>
            <ListItemText primary="Table density" />
            <ListItemSecondaryAction>
              <ToggleButtonGroup
                exclusive
                selected={!!density}
                value={density}
                onChange={onDensityChange}
              >
                <ToggleButton
                  value="comfortable"
                  classes={{
                    selected: classes.selectedButton, root: classes.root
                  }}
                >
                  <ViewStream />
                </ToggleButton>

                <ToggleButton
                  value="default"
                  classes={{
                    selected: classes.selectedButton, root: classes.root
                  }}
                >
                  <ViewList />
                </ToggleButton>

                <ToggleButton
                  value="compact"
                  classes={{
                    selected: classes.selectedButton, root: classes.root
                  }}
                >
                  <ViewHeadline />
                </ToggleButton>

              </ToggleButtonGroup>
            </ListItemSecondaryAction>
          </ListItem>

          <Divider />
          <ListItem>
            <ListItemText primary="Restore to default settings" />
            <ListItemSecondaryAction>
              <IconButton color="primary" onClick={onRestore} size="large">
                <Restore />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </div>
    );
  }
}

GeneralSettings.propTypes = {
  classes: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired
};

export default withStyles(styles)(GeneralSettings);


